import { useMemo, useState } from 'react';
import { CmmFileImport } from '../../services/cmm-import/types.ts';
import { RecordPosition } from '../../types/sharedTypeImpl.ts';
import { ModalSubmitDialog } from '../modalSubmitDialog.tsx';
import { CmmPositionsAccordion } from './cmmPositionsAccordion.tsx';


interface Props {
    isOpen: boolean;
    importResult: CmmFileImport[];
    onCancel: () => void;
    onSubmit: (valuesToImport: RecordPosition[], sharePointFiles: string[]) => void;
}

export function CmmPositionsDialog({
    isOpen,
    importResult,
    onCancel,
    onSubmit,
}: Props) {
    const [importState, setImportState] = useState<CmmFileImport[]>(importResult);


    const handleImportStateChange = (index: number, newImportFileState: CmmFileImport) => {
        const newImportState = [...importState];
        newImportState[index] = newImportFileState;
        setImportState(newImportState);
    };

    const handleSubmit = () => {
        const importValues = new Map<string, RecordPosition>();
        const sharePointFiles: string[] = [];

        for (const file of importState) {
            if (!file.isIncluded) continue;
            if (file.fileSource === 'sharepoint') {
                sharePointFiles.push(file.filename);
            }

            for (const position of file.positions!) {
                if (!position.isIncluded) continue;

                // Later positions overwrite earlier ones, if the same position is selected multiple times
                importValues.set(position.positionNumber, {
                    positionNumber: position.positionNumber,
                    value: position.value,
                    equipmentId: file.equipmentId,
                });
            }
        }

        const importValuesArray = Array.from(importValues.values());
        onSubmit(importValuesArray, sharePointFiles);
    };

    const positionNumberCounts = useMemo(() => {
        const positionNumberCounts = new Map<string, number>();
        for (const file of importState) {
            if (!file.isIncluded) continue;

            for (const position of file.positions!) {
                if (!position.isIncluded) continue;

                const count = positionNumberCounts.get(position.positionNumber) || 0;
                positionNumberCounts.set(position.positionNumber, count + 1);
            }
        }
        return positionNumberCounts;
    }, [importState]);


    if (!isOpen) return null;
    return (
        <ModalSubmitDialog isOpen={isOpen} onCancel={onCancel} onSubmit={handleSubmit}>
            {importState.map((it, index) => (
                <CmmPositionsAccordion
                    key={index}
                    fileIndex={index}
                    importFileResult={it}
                    positionNumberCounts={positionNumberCounts}
                    onChange={handleImportStateChange}
                />
            ))}
        </ModalSubmitDialog >
    )
}
